import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FourSectionStore from './store';
import cx from 'classnames';
import Link from '@src/components/link';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { $$tracker } from '@src/tracker';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.fourSection;

const styles = require('./index.less');

/**
 * FourSection
 * @param store {FourSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FourSection = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.fourSectionRoot, store.isActive && styles.rootActive)}>
      <div className={cx(styles.bg)}>
        <div className={styles.contentBox}>
          <div className={styles.point} />
          <div className={styles.xiaozi} />
          <div className={styles.title_icon}>
            <div className={styles.title} />
          </div>

          <Link
            className={styles.viewDetailsbtn}
            onClick={() => {
              store.openCopyModal();
            }}
          >
            {textInfo.moveMap.btnText}
          </Link>
        </div>
      </div>
      {store.isCopyModal && (
        <div className={styles.modalBox}>
          <div className={styles.modalMask} />
          <div className={cx(styles.modal_bg)}>
            <Link
              className={styles.close}
              onClick={() => {
                store.closeCopyModal();
              }}
            />
            <div className={styles.tipsTxt}>{textInfo.moveMap.copyModal}</div>
            <div className={styles.copyBox}>
              <Link
                className={styles.copy_btn}
                onClick={() => {
                  store.copyUrl();
                  $$tracker.clickDitu();
                }}
              >
                {textInfo.moveMap.copyBtn}
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default wrapStore(FourSection, FourSectionStore);
